import { BRAND_CONFIG } from '@@brand'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'
import { NavLink } from 'react-router'
import { ReactSVG } from 'react-svg'


import { URL_CUSTOMER_PROFILE } from '@shared/contants'

import styles from './styles.module.scss'

interface ItemProps {
  path: string;
  activePath: string | undefined;
  isTablet: boolean;
  onClick: () => void;
}

export default function Item ({
  path,
  activePath,
  isTablet,
  onClick,
}: ItemProps) {
  const { t: tn, i18n } = useTranslation('personal')
  
  // Use brand-specific text for loyalty path
  const getLabelText = () => {
    if (path === 'loyalty') {
      return BRAND_CONFIG.loyalty.nav[i18n.language as 'ru' | 'kk' | 'en'] || BRAND_CONFIG.loyalty.nav.ru
    }
    return tn(`nav.${path}`)
  }
  
  return (
    <NavLink
      onClick={() => (isTablet ? onClick() : null)}
      className={classNames(styles.item, {
        [styles['item--active']]: !isTablet && path === activePath,
      })}
      to={`${URL_CUSTOMER_PROFILE}/${path}`}
    >
      <ReactSVG src={`/icons/personal-nav/${path}.svg`} />
      {getLabelText()}
    </NavLink>
  )
}
